// Curated matriarchal-wisdom traditions. Intros are authored; deeper teachings
// are expanded on demand by Gemini via /api/sanctum/traditions/expand.

export const DOMAINS = [
  { id: "Financial Sovereignty", label: "Financial", blurb: "Wealth, reserves & abundance" },
  { id: "Ancestral Governance", label: "Governance", blurb: "Leadership, legacy & lineage" },
  { id: "Matriarchal Enterprise", label: "Business", blurb: "Building & scaling the work" },
];

export const TRADITIONS = [
  {
    id: "hoodoo",
    name: "Hoodoo",
    region: "Black American Rootwork",
    figures: "Marie Laveau · the Ancestors · root doctors",
    intro:
      "Born of indigenous enslaved Americans in the American South, Hoodoo is ancestral conjure — a practical magic of roots, candles and petition that turns spirit toward tangible outcomes. Its matriarchs kept economies of protection and provision alive under bondage.",
  },
  {
    id: "hindu",
    name: "Hindu Shakti",
    region: "Indian Subcontinent",
    figures: "Lakshmi · Durga · Kali · Saraswati",
    intro:
      "Shakti is the primordial feminine force that animates all creation. The goddesses embody distinct powers — Lakshmi's flowing wealth, Durga's righteous authority, Kali's fearless dissolution, Saraswati's cultivated genius.",
  },
  {
    id: "yoruba",
    name: "Yoruba / Orisha",
    region: "West Africa & Diaspora",
    figures: "Oshun · Yemoja · Oya",
    intro:
      "The Orisha are the crowned mothers of West African cosmology. Yemoja is the deep ocean of reserves and protection; Oshun the sweet river of wealth, diplomacy and ajé; Oya the tempest of transformation and rightful change.",
  },
  {
    id: "native",
    name: "Indigenous American",
    region: "Turtle Island",
    figures: "Spider Grandmother · Corn Mother · Clan Mothers",
    intro:
      "Across many nations, women hold the clan, the seed and the story. Spider Grandmother weaves the world into being; Corn Mother feeds the people; Clan Mothers seat and unseat chiefs — governance rooted in the maternal line.",
  },
  {
    id: "melanesian",
    name: "Melanesian",
    region: "Pacific Islands",
    figures: "Matrilineal clan mothers · land-holding lines",
    intro:
      "In many Melanesian societies land, name and belonging pass through the mother. Wealth is relational — shell valuables, gardens and obligation — and women anchor the networks that hold an island economy together.",
  },
  {
    id: "aboriginal",
    name: "Aboriginal Dreaming",
    region: "Australia",
    figures: "Rainbow Serpent · Ancestral Mothers · Country",
    intro:
      "The world's oldest continuous culture reads law and abundance from Country itself. Ancestral Mothers of the Dreaming laid down the songlines — living maps of water, kinship and obligation that govern how power moves.",
  },
  {
    id: "egyptian",
    name: "Ancient Egyptian",
    region: "Kemet / Nile",
    figures: "Isis · Ma'at · Hathor",
    intro:
      "In Kemet, sovereignty was a feminine principle. Isis mastered the hidden name of power; Ma'at weighed every deed against truth; Hathor governed joy, gold and the pleasure that sustains a throne.",
  },
  {
    id: "greek",
    name: "Ancient Greek",
    region: "Hellenic World",
    figures: "Demeter · Hestia · the Sibyls",
    intro:
      "Before the Olympian order hardened, the mother goddesses reigned. Demeter commanded the harvest and its withholding; Hestia kept the sacred hearth and treasury; the Sibyls spoke prophecy that kings dared not ignore.",
  },
];
